<div class="homepage page-wrapper hide">
    <div class="homepage-inner">
        <div class="wrap-message">
            <h2 class="text-center font-bold">
                {{ 'IRONSIDE.welcome-to-ironside' | translate : { name: name } }}
            </h2>
        </div>
        <div class="main-content-homepage pt-5 pb-0">
            <div class="container">
                <div [formGroup]="searchForm" class="product-search">
                    <h3 class="title text-center">
                        {{ 'IRONSIDE.search-for-product' | translate }}
                    </h3>
                    <div class="wrap-simplified row">
                        <div class="col-xl-3 col-lg-3 col-md-6 px-2">
                            <div class="wrap-select">
                                <label for="">{{ 'IRONSIDE.section-rayon' | translate }}</label>
                                <p-multiSelect
                                    [filter]="true"
                                    class="w-12"
                                    [options]="getFilterTranslate(departments)"
                                    optionLabel="translatedTitle"
                                    optionValue="id"
                                    placeholder="{{
                                        'IRONSIDE.choose-one-or-more-rays' | translate
                                    }}"
                                    formControlName="departments"
                                    appendTo="body"
                                >
                                    <ng-template let-departments pTemplate="item">
                                        <div class="truncate">
                                            {{ departments.title | translateDynamicLanguage }}
                                        </div>
                                    </ng-template>

                                    <ng-template let-value pTemplate="selectedItems">
                                        <div class="truncate">
                                            <span
                                                style="margin-right: 4px"
                                                *ngFor="let option of departmentValue"
                                            >
                                                <span>{{
                                                    option.title | translateDynamicLanguage
                                                }}</span>
                                                <span *ngIf="departmentValue.length > 1">,</span>
                                            </span>
                                        </div>

                                        <span
                                            *ngIf="!departmentValue || departmentValue.length === 0"
                                            >{{
                                                'IRONSIDE.choose-one-or-more-rays' | translate
                                            }}</span
                                        >
                                    </ng-template>
                                </p-multiSelect>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6 px-2">
                            <div class="wrap-select">
                                <label for="">{{ 'IRONSIDE.category' | translate }}</label>
                                <p-dropdown
                                    class="w-12"
                                    [options]="listCategories"
                                    optionLabel="title"
                                    optionValue="id"
                                    [placeholder]="'IRONSIDE.choose-a-category' | translate"
                                    formControlName="categories"
                                    dataKey="id"
                                >
                                    <ng-template let-category pTemplate="item">
                                        <div class="flex align-items-center gap-2">
                                            <div class="truncate">
                                                {{ category.title | translateDynamicLanguage }}
                                            </div>
                                        </div>
                                    </ng-template>

                                    <ng-template let-category pTemplate="selectedItem">
                                        <div class="flex align-items-center gap-2">
                                            <div class="truncate">
                                                {{ category.title | translateDynamicLanguage }}
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-12 px-2">
                            <div class="wrap-input">
                                <label for="">{{ 'IRONSIDE.research' | translate }}</label>

                                <input
                                    (focusout)="emptyList()"
                                    (keyup)="onSearchInput()"
                                    formControlName="research"
                                    type="text"
                                    [placeholder]="
                                        'IRONSIDE.global-search-on-the-catalog' | translate
                                    "
                                    (keydown.enter)="submitHandler()"
                                />
                                <div
                                    class="autocomplete-list"
                                    *ngIf="autocompleteSearchlistProducts.length > 0"
                                >
                                    <ul class="p-0" style="list-style: none">
                                        <li
                                            class="ac-li truncate"
                                            *ngFor="let item of autocompleteSearchlistProducts"
                                            (click)="selectItem(item)"
                                        >
                                            {{
                                                item.shortDescription
                                                    ? item.referenceProduct +
                                                      ' - ' +
                                                      (item.shortDescription
                                                          | translateDynamicLanguage) +
                                                      (item.brand ? ' - ' + item.brand.fr_FR : '')
                                                    : ''
                                            }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div [ngClass]="{ active: isAdvancedActive }" class="wrap-advanced row">
                        <div
                            class="col-xl-5 col-lg-5 col-md-12 px-2"
                            *ngIf="permissionService.isPermissionFonction('visibilite-tarifs')"
                        >
                            <div class="wrap-select">
                                <label for="">{{ 'IRONSIDE.suppliers' | translate }}</label>
                                <p-multiSelect
                                    class="w-12"
                                    [options]="listSuppliers"
                                    optionLabel="title"
                                    optionValue="id"
                                    [placeholder]="
                                        'IRONSIDE.product-list.choose-suppliers' | translate
                                    "
                                    formControlName="suppliers"
                                    (onChange)="onChange()"
                                >
                                    <ng-template let-departments pTemplate="item">
                                        <div class="truncate">
                                            {{ departments.title }}
                                        </div>
                                    </ng-template>

                                    <ng-template let-value pTemplate="selectedItems">
                                        <div class="truncate">
                                            <span
                                                style="margin-right: 4px"
                                                *ngFor="let option of supplierValue"
                                            >
                                                <span>{{ option.title }}</span>
                                                <span *ngIf="supplierValue.length > 1">,</span>
                                            </span>
                                        </div>

                                        <span
                                            *ngIf="!supplierValue || supplierValue.length === 0"
                                            >{{
                                                'IRONSIDE.product-list.choose-suppliers' | translate
                                            }}</span
                                        >
                                    </ng-template>
                                </p-multiSelect>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-md-12 px-2">
                            <div class="wrap-select">
                                <label for="">{{ 'IRONSIDE.select-by' | translate }}</label>
                                <p-multiSelect
                                    [options]="partners"
                                    optionLabel="title"
                                    optionValue="id"
                                    [filter]="true"
                                    [placeholder]="
                                        'IRONSIDE.choose-one-or-more-partners' | translate
                                    "
                                    formControlName="partners"
                                ></p-multiSelect>
                            </div>
                        </div>
                        <div class="group-radio-btn col-2 d-flex justify-content-between py-1">
                            <div class="p-0">
                                <label class="label-form font-bold mb-1" for="">{{
                                    'IRONSIDE.new-product' | translate
                                }}</label>
                                <div class="flex align-items-center gap-3 pt-1">
                                    <p-checkbox
                                        formControlName="isNewProduct"
                                        [binary]="true"
                                        inputId="cli1"
                                    ></p-checkbox>
                                    <label for="cli1" class="m-0">
                                        {{ 'IRONSIDE.yes' | translate }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="group-btn text-center">
                        <button (click)="submitHandler()" class="btn-common btn-rechercher">
                            {{ 'IRONSIDE.SEARCH' | translate }}
                        </button>
                        <button (click)="toggleAdvanced()" class="btn-move truncate">
                            <span *ngIf="isAdvancedActive">{{
                                'IRONSIDE.simple-search' | translate
                            }}</span>
                            <span *ngIf="!isAdvancedActive">{{
                                'IRONSIDE.advanced-search' | translate
                            }}</span>
                            <i
                                [className]="
                                    isAdvancedActive
                                        ? 'pi pi-chevron-up ml-2 fs-5'
                                        : 'pi pi-chevron-down ml-2 fs-5'
                                "
                            ></i>
                        </button>
                    </div>
                </div>
                <div *ngIf="roleUser === '[Extranet - Fournisseur]'" class="table-control">
                    <h3 class="title text-center">{{ 'IRONSIDE.my-dashboard' | translate }}</h3>
                    <div class="wrap-block d-flex justify-content-between">
                        <div class="wrap-chart">
                            <p class="child-title mb-3">
                                {{ 'IRONSIDE.item-filling-rate' | translate }}
                            </p>
                        </div>
                        <div class="wrap-table">
                            <div
                                class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-1"
                            >
                                <p class="child-title mb-0">
                                    {{ 'IRONSIDE.visualization-of-frames' | translate }}
                                </p>
                                <button class="btn-common btn-import">
                                    {{ 'IRONSIDE.import-a-frame' | translate }}
                                </button>
                            </div>
                            <div class="table">
                                <p-table [value]="dataViewingFrames">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th class="font-bold" style="min-width: 70px">
                                                {{ 'IRONSIDE.import-date' | translate }}
                                            </th>
                                            <th class="font-bold">
                                                {{ 'IRONSIDE.Nom du fichier Excel' | translate }}
                                            </th>
                                            <th class="font-bold">
                                                {{ 'IRONSIDE.amount-status' | translate }}
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-item>
                                        <tr>
                                            <td>{{ item?.dateImport ? item?.dateImport : '-' }}</td>
                                            <td>{{ item?.nameFile ? item?.nameFile : '-' }}</td>
                                            <td>{{ item?.status ? item?.status : '-' }}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="newProducts?.length" class="news-carousel custom-carousel">
                    <h2 class="font-bold">{{ 'IRONSIDE.NEW-PRODUCTS' | translate }}</h2>
                    <div class="px-80 wrap-carousel">
                        <p-carousel
                            [value]="newProducts"
                            [numVisible]="4"
                            [numScroll]="4"
                            [circular]="false"
                            [responsiveOptions]="responsiveOptions"
                        >
                            <ng-template let-new pTemplate="item">
                                <div
                                    (click)="toProductDetail(new?.referenceProduct)"
                                    class="item-news item-custom"
                                >
                                    <div class="relative mb-1" style="height: 180px">
                                        <img
                                            [src]="getResourceValid(new?.fullExtendData)"
                                            alt="img"
                                            style="object-fit: contain"
                                            class="w-full border-round"
                                        />
                                    </div>

                                    <div class="title-wrap">
                                        <p class="title-news font-bold">
                                            {{ new.shortDescription | translateDynamicLanguage }}
                                        </p>
                                    </div>
                                </div>
                            </ng-template>
                        </p-carousel>
                    </div>
                </div>
            </div>
            <div
                *ngIf="isPermissionFonctions('yellow-focus-home')"
                class="news-carousel yellow-forcus"
            >
                <div class="container">
                    <h2 class="font-bold">{{ 'IRONSIDE.YELLOW-FOCUS' | translate }}</h2>
                    <div class="px-80 wrap-carousel">
                        <p-carousel
                            [value]="news"
                            [numVisible]="4"
                            [numScroll]="4"
                            [circular]="false"
                            [responsiveOptions]="responsiveOptions"
                        >
                            <ng-template let-new pTemplate="item">
                                <div (click)="showNewsDetail(new.id)" class="item-news">
                                    <div class="relative mb-1" style="height: 230px">
                                        <img
                                            *ngIf="new?.imageURL"
                                            [src]="new.imageURL"
                                            alt=""
                                            class="w-full border-round"
                                        />

                                        <p-skeleton
                                            *ngIf="!new?.imageURL"
                                            width="100%"
                                            height="100%"
                                        ></p-skeleton>
                                    </div>
                                    <p class="title-news font-bold mb-2">
                                        {{ new?.title | translateDynamicLanguage }}
                                    </p>
                                    <p class="desc mb-1">
                                        {{ new?.description | translateDynamicLanguage }}
                                    </p>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <a>{{ 'IRONSIDE.learn-more' | translate }}</a>
                                    </div>
                                </div>
                            </ng-template>
                        </p-carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
